import React from 'react';
import styled from 'styled-components';
import { Link, NavLink } from 'react-router-dom';
import { WSAEDESTADDRREQ } from '../../constants';

/*

Props:

• fontSize
• letterSpacing
• marginLeft
• marginRight
• color

*/

const SCDiv = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    color: ${props => (props.color) ? props.color : '#7b7b7b'};
    ${props => (props.gradient) ?  
        `background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(0,0,0,0.30) 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(0,0,0,0.30) 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(0,0,0,0.30) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#94000000',GradientType=0 ); /* IE6-9 */  }
        background: -moz-linear-gradient(top, rgba(255,255,255,0) 0%, rgba(0,0,0,0.30) 100%); /* FF3.6-15 */
        background: -webkit-linear-gradient(top, rgba(255,255,255,0) 0%,rgba(0,0,0,0.30) 100%); /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(to bottom, rgba(255,255,255,0) 0%,rgba(0,0,0,0.30) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#94000000',GradientType=0 ); /* IE6-9 */`
        : ''}


`;

const BackgroundGradient = ({  children, styles, ...rest }) => (
  <SCDiv  style = {styles} {...rest}>
      { children }
  </SCDiv>
);

export default BackgroundGradient;

// linkStyle: {
//     marginLeft: 30,
//     color: 'rgba(255,255,255,0.8)',
//     fontSize: 14,
//     letterSpacing: '0.08em',
//     textDecoration: 'none',
// },


// WEBPACK FOOTER //
// ./src/js/components/DivStyleAdders/BackgroundGradient.jsx